import styled, { css } from 'styled-components';

import { BaseButtonPropsT } from './Button';

const DEFAULT_BUTTON_HEIGHT = 38;

const defaultButton = styled.button<BaseButtonPropsT>`
  position: relative;
  padding: 12px 20px;
  line-height: 1;

  ${({ isFullWidth, isFullHeight, icon }) => `
    ${isFullWidth ? `width: 100%` : ''};
    ${isFullHeight ? `height: 100%` : ''};
    ${Boolean(icon) ? `display: flex; align-items: center` : ''};  
  `}

  ${({ theme, isLoading, isInverted, isUpperCase, isRounded }) => `
    min-height: ${DEFAULT_BUTTON_HEIGHT}px;
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.small};

    ${isRounded ? 'border-radius: 25px;' : ''}
    ${isInverted ? `background-color: ${theme.primaryColour};` : ''}
    color: ${isInverted ? theme.whiteColour : theme.textColour};
    border: 1px solid ${theme.primaryColour};

    ${isUpperCase ? 'text-transform: uppercase;' : ''}

    &:hover {
      background-color: ${theme.primaryColour};
      color: ${theme.whiteColour};
    }

    &[disabled] {
      color: ${isLoading ? 'transparent' : theme.whiteColour};
      background: #e0e0e0;
      cursor: not-allowed;
      border: none;

      &:hover {
        color: ${isLoading ? 'transparent' : theme.whiteColour};
      }
    }
  `}
`;

const muralTo = css`
  border-radius: 0;
`;

const counter = css`
  width: 42px;
  height: 42px;
  padding: 0;
  border-radius: 4px;
`;

const inline = css`
  padding: 0;
  border: 0;
  min-height: auto;

  ${({ theme }) => `
    &:hover {
      background-color: transparent;
      color: ${theme.textColour};
    }
  `}
`;

const link = css`
  padding: 0;
  border: 0;
  min-height: auto;

  ${({ theme }) => `
    color: ${theme.primaryColour};
    text-decoration: underline;
    text-transform: inherit;

    &:hover {
      background-color: transparent;
      color: ${theme.primaryColour};
      text-decoration: none;
    }
  `}
`;

export const IconWrapStyled = styled.span`
  display: block;
  width: 11px;
  margin-right: 9px;
`;

export const ButtonStyled = styled(defaultButton)`
  ${({ modifier }) => {
    switch (modifier) {
      case 'muralto':
        return muralTo;
      case 'counter':
        return counter;
      case 'inline':
        return inline;
      case 'link':
        return link;
      default:
        return null;
    }
  }}
`;
